import React from 'react';
import { Alert } from 'react-bootstrap';

const toast = (props) => (
  <Alert
    style={{ position: 'fixed', top: '1%', right: '1%', zIndex: '1000' }}
    bsStyle={props.type}
    onDismiss={props.handleDismiss}
  >
    <h4>Whoops</h4>
    <div>{props.error}</div>
  </Alert>
);

export default toast;
